import React, { useState, useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { isVideo } from "@/lib/media";

export function Lightbox({ images = [], index = 0, onClose }) {
  const [i, setI] = useState(index);

  useEffect(() => setI(index), [index]);

  const prev = useCallback((e) => { e?.stopPropagation(); setI((p) => (p - 1 + images.length) % images.length); }, [images.length]);
  const next = useCallback((e) => { e?.stopPropagation(); setI((p) => (p + 1) % images.length); }, [images.length]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [onClose, prev, next]);

  if (!images.length) return null;

  return (
    <div
      data-testid="lightbox"
      onClick={onClose}
      className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center animate-fade-up"
      style={{ animationDuration: "0.2s" }}
    >
      <button data-testid="lightbox-close" onClick={onClose}
        className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors">
        <X className="w-6 h-6" />
      </button>

      {images.length > 1 && (
        <>
          <button data-testid="lightbox-prev" onClick={prev}
            className="absolute left-3 md:left-6 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors">
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button data-testid="lightbox-next" onClick={next}
            className="absolute right-3 md:right-6 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors">
            <ChevronRight className="w-6 h-6" />
          </button>
        </>
      )}

      {isVideo(images[i]) ? (
        <video
          src={images[i]}
          controls
          autoPlay
          onClick={(e) => e.stopPropagation()}
          className="max-h-[88vh] max-w-[92vw] rounded-2xl shadow-2xl bg-black"
        />
      ) : (
        <img
          src={images[i]}
          alt=""
          onClick={(e) => e.stopPropagation()}
          className="max-h-[88vh] max-w-[92vw] object-contain rounded-2xl shadow-2xl"
        />
      )}

      {images.length > 1 && (
        <div className="absolute bottom-6 text-white/80 text-sm font-medium">{i + 1} / {images.length}</div>
      )}
    </div>
  );
}
